import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

interface SuperAdminRouteProps {
  children: React.ReactNode
}

/**
 * SuperAdminRoute guards routes that should only be visible to super_admin.
 * Non-super-admin users are sent to /access-denied. The backend still gates
 * the underlying API calls (403 PERMISSION_DENIED).
 */
export const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, isSuperAdmin } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background-light dark:bg-background-dark">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-500 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!isSuperAdmin()) {
    return <Navigate to="/access-denied" replace />
  }

  return <>{children}</>
}

export default SuperAdminRoute
